var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"28px","color":"#3761E1","font-weight":"700"}},[_c('elt-icon',{attrs:{"size":_vm.size,"icon":_vm.icon}}),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }